import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
    DesignRevisionReason,
    DesignRevisionReasonEditModel,
    ListDesignRevisionReasonsParams,
} from '../model/design-revision-reason';

const basePath = '/api/design-revision-reasons';

/**
 * HTTP client for the reasons on the 返修判断管理 settings page. Every endpoint requires
 * `write:design-revision-reason`; the reasons QC picks from while judging are served separately by
 * `TreatmentDesignRevisionClient`, and the liabilities they are filed under by
 * `RevisionLiabilityClient`.
 */
@Injectable({ providedIn: 'root' })
export class DesignRevisionReasonClient {
    private readonly _httpClient = inject(HttpClient);

    list(params: ListDesignRevisionReasonsParams): Observable<DesignRevisionReason[]> {
        let httpParams = new HttpParams();
        if (params.treatmentTypeOriginalId != null) {
            httpParams = httpParams.set('treatmentTypeOriginalId', String(params.treatmentTypeOriginalId));
        }
        if (params.revisionLiability != null) {
            httpParams = httpParams.set('revisionLiability', String(params.revisionLiability));
        }
        if (params.isActive != null) {
            httpParams = httpParams.set('isActive', String(params.isActive));
        }
        if (params.search != null && params.search.length > 0) {
            httpParams = httpParams.set('search', params.search);
        }
        if (params.includeAllTypes === true) {
            httpParams = httpParams.set('includeAllTypes', 'true');
        }
        if (params.onlyAllTypes === true) {
            httpParams = httpParams.set('onlyAllTypes', 'true');
        }
        return this._httpClient.get<DesignRevisionReason[]>(basePath, { params: httpParams });
    }

    create(model: DesignRevisionReasonEditModel): Observable<DesignRevisionReason> {
        return this._httpClient.post<DesignRevisionReason>(basePath, model);
    }

    update(id: number, model: DesignRevisionReasonEditModel): Observable<DesignRevisionReason> {
        return this._httpClient.put<DesignRevisionReason>(`${basePath}/${id}`, model);
    }

    setActive(id: number, isActive: boolean): Observable<DesignRevisionReason> {
        return this._httpClient.patch<DesignRevisionReason>(`${basePath}/${id}/active`, isActive);
    }

    /** Only allowed while no judgement points at the reason; otherwise the API answers 409. */
    delete(id: number): Observable<void> {
        return this._httpClient.delete<void>(`${basePath}/${id}`);
    }
}
